import React from 'react';

import { Button, Text } from '@change/ds-core-ui';
import { SparkleIcon } from '@change/ds-icons';

import { TranslateHtml, useI18n } from '@change-corgi/core/react/i18n';

import { Waypoint } from 'src/app/shared/components/scroll';

export const CtaSection: React.FC<CtaSectionProps> = ({ onCtaClick, onCtaView }) => {
	const { translate } = useI18n();

	return (
		<div className="bg-gradient-background-dark-2">
			<Waypoint onEnter={onCtaView} />
			<div className="container flex flex-col items-center gap-13 py-20 text-center">
				<Text as="h2" variant="heading" size="large" className="text-typography-inverse-strong">
					<TranslateHtml value="corgi.start_a_petition.chat_app_entry.cta_heading" />
				</Text>

				<Button
					className="w-full max-w-87.5"
					variant="primary"
					leadingIcon={<SparkleIcon />}
					data-qa="chat-app-entry-footer-cta-button"
					onClick={onCtaClick}
				>
					{translate('corgi.start_a_petition.chat_app_entry.cta_button')}
				</Button>
			</div>
		</div>
	);
};

type CtaSectionProps = {
	onCtaClick?: () => void;
	onCtaView?: () => void;
};
